export function resolvePictureUrl(picture, fallback = '/static_images/no_image.png') {
  if (!picture || String(picture).trim() === '') {
    return fallback
  }

  const value = String(picture).trim()
  if (/^https?:\/\//i.test(value) || value.startsWith('//')) {
    return value
  }

  return value.startsWith('/') ? value : `//${value}`
}
